import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Observable, Subject } from 'rxjs';

import { Store } from '@ngrx/store';

import { environment } from '../../../environments/environment';
import { SseService } from '../../core/services/sse.service';
import { SnackBarComponent } from '../../shared/components/snack-bar/snack-bar.component';

import { Notification } from './models/notification.model';
import { OrgsSummaryResponse } from './models/orgs-summary-response.model';
import { fetchNotificationsCountStart } from './state/notifications.actions';

@Injectable({
	providedIn: 'root',
})
export class NotificationsService {
	apiUrl = `${environment.apiUrl}/notification-logs`;

	drawer: Notification[] = [];

	initialized = false;
	sseInitialized = false;
	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly http: HttpClient,
		private readonly store: Store,
		private readonly snackbar: MatSnackBar,
		private readonly sse: SseService,
	) {
		this.sse.message$.asObservable().subscribe((notification) => {
			this.drawer.push(notification);
		});
	}

	emptyDrawer(): void {
		this.drawer = [];
	}

	fetchBellCount(): void {
		if (!this.initialized) {
			this.initialized = true;
			this.store.dispatch(fetchNotificationsCountStart());
		}
	}

	/**
	 * Fetch notification list
	 * @param orgId? string
	 */
	getNotificationList(orgId?: string): Observable<Notification[]> {
		let url = `${this.apiUrl}/users/me`;

		if (orgId) {
			url = `${this.apiUrl}/users/me/organizations/${orgId}`;
		}

		return this.http.get<Notification[]>(url);
	}

	/**
	 * Fetch unread notifications count
	 */
	getNotificationsCount(): Observable<number> {
		const url = `${this.apiUrl}/users/me/count`;

		return this.http.get<number>(url);
	}

	/**
	 * Fetch organizations summary
	 */
	getOrgsSummary(): Observable<OrgsSummaryResponse> {
		const url = `${environment.apiUrl}/organization`;

		return this.http.get<OrgsSummaryResponse>(url);
	}

	initializePopups(): void {
		if (!this.sseInitialized) {
			this.sseInitialized = true;
			this.sse.startEventSource(`${this.apiUrl}/sse`);
		}
	}

	showSnack(info: string, type: string) {
		this.snackbar.openFromComponent(SnackBarComponent, {
			data: { info, type },
		});
	}

	stopNotifications(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	stopPopups(): void {
		if (this.sseInitialized) {
			this.sse.closeEventSources();
			this.sseInitialized = false;
		}
	}

	updateBellCount(): void {
		this.store.dispatch(fetchNotificationsCountStart());
	}
}
